import axios from "axios";
import React, { useEffect, useState } from "react";
import { Modal, Col } from "react-bootstrap";
import { ErrorMessage, Field, Form, Formik, useFormik } from "formik";
import { toast } from "react-toastify";
import { BASE_URL } from "../../../redux/services/apiPath";
import Select from "react-select";
import * as Yup from "yup";
import authHeader from "../../../redux/services/authHeader";
import { upperCase } from "../../../constants";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  addon: Yup.array().required("Add on is required").min(1),
});

const CreateGroupAddons = (props) => {
  let addons = props.currentItems;
  const [initialValues, setInitialValues] = useState({
    name: "",
    addon: [],
    isActive: true,
  });
  useEffect(() => {
    setInitialValues({
      name: props?.data?.name || "",
      addon: props?.data?.addon || "",
      isRequired: props?.data?.isRequired || false,
      multiple: props?.data?.multiple || false,
      isActive: props?.data?.isActive || true,
      addonGroupId: props?.data?._id || "",
    });
  }, [props?.data]);

  const handleSubmit = async (values) => {
    let { name, addon, isActive, isRequired, multiple, addonGroupId } = {
      ...values,
    };

    console.log("values", values);
    let ids = addon?.map((val) => val);
    const data = {
      vendorId: localStorage.getItem("vendorId")
        ? localStorage.getItem("vendorId")
        : "",
      name,
      isActive,
      addonGroupId,
      isRequired: values?.isRequired === "true" || values.isRequired === true,
      multiple: values?.multiple === "true" || values.multiple === true,
      addon: ids,
    };
    let url = ``;
    if (values?.addonGroupId) {
      url = `${BASE_URL}addon/updateAddOnGroup`;
    } else {
      url = `${BASE_URL}addon/createAddOnGroup`;
      delete data?.addonGroupId;
    }
    const res = await axios.post(url, data, authHeader());

    if (res?.data?.status == "success") {
      toast.success(res?.data?.message);

      props.onHide();
    } else {
      toast.error("Something Went Wrong ");
    }
  };

  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Create Addon
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              <div className="ms-panel ms-panel-fh">
                <div className="ms-panel-body">
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize
                  >
                    {(formik) => (
                      <Form className="needs-validation clearfix" noValidate>
                        <div className="form-row">
                          <div className="col-md-12 mb-3">
                            <label htmlFor="name">
                              Name<span className="error">*</span>
                            </label>
                            <Field
                              type="text"
                              className={`form-control ${
                                formik.errors.name && formik.touched.name
                                  ? "is-invalid"
                                  : ""
                              }`}
                              value={formik?.values?.name}
                              id="name"
                              name="name"
                              placeholder="Addon Name"
                            />
                            <ErrorMessage
                              name="name"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                          <div className="col-md-12 mb-3">
                            <label htmlFor="validationCustom01">
                              Select addon<span className="error">*</span>
                            </label>
                            <Select
                              isMulti
                              name="addon"
                              options={addons.map((c) => ({
                                value: c._id,
                                label: upperCase(c.name),
                              }))}
                              value={addons
                                .filter((c) =>
                                  formik.values.addon?.includes(c._id)
                                )
                                .map((c) => ({
                                  value: c._id,
                                  label: upperCase(c.name),
                                }))}
                              onChange={(selectedOptions) => {
                                formik.setFieldValue(
                                  "addon",
                                  selectedOptions
                                    ? selectedOptions.map((opt) => opt.value)
                                    : []
                                );
                              }}
                              className="basic-multi-select"
                              classNamePrefix="select"
                            />

                            <ErrorMessage
                              name="price"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>

                          <div className="col-md-12 mb-3">
                            <label htmlFor="isActive">
                              Is Active<span className="error">*</span>
                            </label>
                            <select
                              name="isActive"
                              onChange={(e) => {
                                formik.setFieldValue(
                                  "isRequired",
                                  e.target.value
                                );
                              }}
                              value={formik?.values?.isActive}
                              className={`form-control ${
                                formik.errors.isActive &&
                                formik.touched.isActive
                                  ? "is-invalid"
                                  : ""
                              }`}
                            >
                              <option value="">Select Option</option>
                              <option value={true}>Active</option>
                              <option value={false}>Inactive</option>
                            </select>
                            <ErrorMessage
                              name="isActive"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>

                          <div className="col-md-12 mb-3">
                            <label htmlFor="isRequired">
                              Is Required<span className="error">*</span>
                            </label>
                            <select
                              name="isRequired"
                              value={formik?.values?.isRequired}
                              onChange={(e) => {
                                formik.setFieldValue(
                                  "isRequired",
                                  e.target.value
                                );
                              }}
                              className={`form-control ${
                                formik.errors.isRequired &&
                                formik.touched.isRequired
                                  ? "is-invalid"
                                  : ""
                              }`}
                            >
                              <option value="">Select Option</option>
                              <option value={true}>Yes</option>
                              <option value={false}>No</option>
                            </select>
                            <ErrorMessage
                              name="isRequired"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>

                          <div className="col-md-12 mb-3">
                            <label htmlFor="isRequired">
                              is Multiple<span className="error">*</span>
                            </label>
                            <select
                              name="multiple"
                              value={formik?.values?.multiple}
                              onChange={(e) => {
                                formik.setFieldValue(
                                  "multiple",
                                  e.target.value
                                );
                              }}
                              className={`form-control ${
                                formik.errors.multiple &&
                                formik.touched.multiple
                                  ? "is-invalid"
                                  : ""
                              }`}
                            >
                              <option value="">Select Option</option>
                              <option value={true}>Yes</option>
                              <option value={false}>No</option>
                            </select>
                            <ErrorMessage
                              name="multiple"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </div>

                        <button type="submit" className="btn btn-primary">
                          Submit
                        </button>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CreateGroupAddons;
